<template>
  <div class="kakunin">
    <div class="kakunin-step">
      <FormStep v-bind:step="2"></FormStep>
    </div>

    <div class="kakunin-form">
      <FormWaku v-for="(i, index) in kakunin_form" v-bind:key="index">
        <template v-slot:title>{{ form_name[index] }}</template>
        <template>
          <P class="warp">{{ i }}</P>
        </template>
      </FormWaku>
    </div>
    <div v-on:click="soushin">
      <FormBtn>
        <template>この内容で送信する</template>
      </FormBtn>
    </div>
  </div>
</template>

<script>
import FormWaku from "@/components/form_waku.vue";
import FormStep from "@/components/form_step.vue";
import FormBtn from "@/components/form_btn.vue";
var form_name = {
  job: "職種選択",
  kinmuchi: "希望勤務地",
  namae: "お名前",
  furigana: "ふりがな",
  seibetsu: "性別",
  age: "年齢",
  juusyo: "住所",
  tel: "電話番号",
  mail: "メールアドレス",
  beforCompany: "直近の在籍会社名",
  zaiseki: "在籍期間",
  gyoumunaiyou: "前職業務内容",
  ziki: "入社可能時期",
  question: "ご質問･ご要望など"
};
export default {
  metaInfo: {
    title: "入力内容確認"
  },
  name: "kakunin-form",
  components: {
    FormWaku,
    FormStep,
    FormBtn
  },
  props: ["form_data", "click"],
  methods: {
    soushin() {
      //入力内容をfetchで送る
      var formData = new FormData();
      formData.append("form_data", JSON.stringify(this.form_data));
      fetch("https://famitei.co.jp/career/api/send.php", {
        method: "POST",
        body: formData,
        cors: true
      });
      //ローカルストレージを削除
      this.$emit("removeData");
      //送信完了画面に飛ぶ
      this.$router.push("/soushin");
    }
  },
  mounted() {
    //リロードしてもフォーム画面に戻らないようにする
    window.scroll(top);
    if (window.performance) {
      if (performance.navigation.type === 1) {
        this.$emit("click_kakunin");
      }
    }
    this.$nextTick(() => {
      if (!this.click) {
        this.$router.replace("/");
      }
    });
  },
  computed: {
    //入力確認画面表示内容
    kakunin_form() {
      var data = {};
      var toString = Object.prototype.toString;
      var check = function(i, ii) {
        if(toString.call(i).match(/Object/) && Object.values(i).some(o => o)){
            return ii(i);
          }
        if (!toString.call(i).match(/Object/) && i) {
          if (ii) {
            return ii(i);
          }
          return i;
        }
        return "入力なし";
      };
      data.job = this.form_data.job;
      data.kinmuchi = this.form_data.kinmuchi.join("/");
      data.namae = this.form_data.name.kanji;
      data.furigana = this.form_data.name.furigana;
      data.seibetsu = this.form_data.seibetsu;
      data.age = this.form_data.age + "歳";
      data.juusyo = check(this.form_data.juusyo, function(juusyo) {
        return "〒" + juusyo.yuubin_num + "\n" + juusyo.address;
      });
      data.tel = this.form_data.tel;
      data.mail = this.form_data.mail;
      data.beforCompany = this.form_data.beforCompany;
      data.zaiseki = this.form_data.zaiseki;
      data.gyoumunaiyou = this.form_data.gyoumunaiyou;
      data.ziki = check(this.form_data.ziki, function(ziki) {
        return ziki.year + "年" + ziki.month + "月";
      });
      data.question = check(this.form_data.question);
      return data;
    },
    form_name() {
      return form_name;
    }
  }
};
</script>
<style lang="scss">
.kakunin {
  & .warp {
    white-space: pre-wrap;
  }
  //pc style
  @media screen and (min-width: 769px) {
    &-form {
      border: 1px solid #c8c8c8;
      max-width: 800px;
      margin: 10px auto;
    }
  }
  &-btn {
    text-align: center;
  }
}
</style>
